(function () {
    'use strict';

    angular
        .module('homeControllers')
        .controller('RootController', Controller);

    Controller.$inject = ['$scope', '$state', 'authenticatedUser'];

    function Controller($scope, $state, authenticatedUser) {

        if (!_.isNull(authenticatedUser) &&
            !_.isUndefined(authenticatedUser.MetaDataUser)) {

            $state.go('home', { UserItemPersonID: authenticatedUser.MetaDataUser.ItemPersonID }, {location: 'replace'});
        }
    }
})();
